import { getNavigationTreeHashCode } from "@faire/retailer-visitor-shared/serialized-data/getNavigationTreeHashCode";
export var useNavigationTreeQueryParams = function(filterablePaginatedSection) {
    var navigationTreeRequest = filterablePaginatedSection.get_s_d_u_i_navigation_tree_request;
    var _navigationTreeRequest_navigation_path;
    return {
        navigation_path: (_navigationTreeRequest_navigation_path = navigationTreeRequest === null || navigationTreeRequest === void 0 ? void 0 : navigationTreeRequest.navigation_path) !== null && _navigationTreeRequest_navigation_path !== void 0 ? _navigationTreeRequest_navigation_path : "",
        navigation_tree_hash_code: getNavigationTreeHashCode()
    };
};
